import React, { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import axios from "axios";
import toast from "react-hot-toast";
import { AuthContext } from "../../../context/Authcontext";

const base_url = process.env.REACT_APP_API_URL;

const DeletedBets = () => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [history, setHistory] = useState([]);
  const [filteredHistory, setFilteredHistory] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);

  const { getRoles } = useContext(AuthContext);

  const [isSidebarOpen, setIsSidebarOpen] = useState(
    !(window.innerWidth < 768)
  );

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) setIsSidebarOpen(true);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getDeletedBets = async () => {
    try {
      const auth = localStorage.getItem("admin");
      const response = await axios.get(`${base_url}/api/admin/getAllDeletedBets`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${auth}`,
        },
      });

      console.log("response is:", response.data.data);
      setHistory(response.data.data);
      setFilteredHistory(response.data.data);
    } catch (error) {
      console.error("Error fetching deleted bets:", error);
      toast.error("Error fetching deleted bets");
    }
  };

  useEffect(() => {
    getDeletedBets();
  }, []);

  // Filter function
  const applyFilters = useCallback(() => {
    let filtered = [...history];

    // Date filter
    if (fromDate || toDate) {
      filtered = filtered.filter((bet) => {
        const betDate = new Date(bet.time);
        const from = fromDate ? new Date(fromDate) : null;
        const to = toDate ? new Date(toDate) : null;

        if (from && to) {
          return betDate >= from && betDate <= to;
        } else if (from) {
          return betDate >= from;
        } else if (to) {
          return betDate <= to;
        }
        return true;
      });
    }

    // Search filter
    if (searchTerm) {
      filtered = filtered.filter((bet) =>
        bet.eventName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        bet.sportname?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        bet.competitionName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        bet.runnerName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        bet.type?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        bet.phone?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        bet.id?.toString().includes(searchTerm)
      );
    }

    setFilteredHistory(filtered);
    setCurrentPage(1); // Reset to first page when filtering
  }, [history, fromDate, toDate, searchTerm]);

  useEffect(() => {
    applyFilters();
  }, [applyFilters]);

  // Handle filter button click
  const handleFilter = () => {
    applyFilters();
    toast.success("Filters applied successfully");
  };

  // Handle refresh button click
  const handleRefresh = () => {
    setFromDate("");
    setToDate("");
    setSearchTerm("");
    setRowsPerPage(25);
    setCurrentPage(1);
    getDeletedBets();
    toast.success("Data refreshed");
  };

  // Pagination logic
  const totalPages = Math.ceil(filteredHistory.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const currentData = filteredHistory.slice(startIndex, endIndex);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(parseInt(e.target.value));
    setCurrentPage(1);
  };

  return (
    <div className="wrapper">
  
      <div
        className={`content-wrapper d-flex flex-column ${
          !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
        }`}
        style={{
          marginLeft: !isMobile && isSidebarOpen ? "" : "0",
          transition: "margin-left 0.3s ease",
        }}
      >
        {/* Filter Section */}
        <div className="container-fluid p-3">
          <div className="row mb-3">
            <div className="col-md-2">
              <input
                type="date"
                className="form-control"
                placeholder="From Date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                style={{ fontSize: '14px' }}
              />
            </div>
            <div className="col-md-2">
              <input
                type="date"
                className="form-control"
                placeholder="To Date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                style={{ fontSize: '14px' }}
              />
            </div>
            <div className="col-md-2">
              <button
                className="btn btn-primary me-2"
                onClick={handleFilter}
                style={{ fontSize: '14px', padding: '8px 16px' }}
              >
                Filter
              </button>
              <button
                className="btn btn-secondary"
                onClick={handleRefresh}
                style={{ fontSize: '14px', padding: '8px 16px' }}
              >
                Refresh
              </button>
            </div>
          </div>
          
          <div className="row mb-3">
            <div className="col-md-3">
              <input
                type="text"
                className="form-control"
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{ fontSize: '14px' }}
              />
            </div>
            <div className="col-md-2">
              <div className="d-flex align-items-center">
                <span className="me-2" style={{ fontSize: '14px' }}>Rows</span>
                <select
                  className="form-select"
                  value={rowsPerPage}
                  onChange={handleRowsPerPageChange}
                  style={{ fontSize: '14px' }}
                >
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
              </div>
            </div>
            <div className="col-md-7">
              <div className="text-muted" style={{ fontSize: '14px', paddingTop: '8px' }}>
                Showing {startIndex + 1} to {Math.min(endIndex, filteredHistory.length)} of {filteredHistory.length} entries
              </div>
            </div>
          </div>
        </div>

        {/* Table Section */}
        <div className="container-fluid p-0">
          <div className="table-responsive">
            <table className="table table-bordered table-striped mb-0" style={{fontSize: '12px'}}>
              <thead>
                <tr style={{backgroundColor: '#3c4b64', color: 'white'}}>
                  <th className="text-start py-2 px-3" style={{minWidth: '250px'}}>Description</th>
                  <th className="text-start py-2 px-3" style={{minWidth: '200px'}}>Market</th>
                  <th className="text-start py-2 px-3" style={{minWidth: '80px'}}>Odds</th>
                  <th className="text-start py-2 px-3" style={{minWidth: '80px'}}>Stake</th>
                </tr>
              </thead>
              <tbody>
                {currentData.length > 0 ? (
                  currentData.map((bet, index) => (
                    <tr key={bet.id || index} style={{backgroundColor: index % 2 === 0 ? '#f8f9fa' : 'white'}}>
                      <td className="py-2 px-3">
                        <div className="d-flex flex-column">
                          <div className="d-flex align-items-center mb-1">
                            <span style={{color: '#dc3545', fontWeight: 'bold'}}>
                              {bet.sportname} | {bet.competitionName} <span style={{fontStyle: 'italic'}}>(D)</span>
                            </span>
                            <span 
                              className="ms-2 rounded-circle d-inline-flex align-items-center justify-content-center" 
                              style={{
                                backgroundColor: '#6c757d', 
                                color: 'white', 
                                width: '16px', 
                                height: '16px', 
                                fontSize: '10px',
                                fontWeight: 'bold'
                              }}
                            >
                              i
                            </span>
                          </div>
                          <div className="mb-1">
                            <span style={{color: '#dc3545', fontWeight: 'bold'}}>{bet.eventName}</span>
                            <span 
                              className={`ms-2 px-2 py-1 rounded text-white`}
                              style={{
                                backgroundColor: bet.side === 'Back' ? '#007bff' : bet.side === 'Lay' ? '#6f42c1' : '#28a745',
                                fontSize: '10px',
                                fontWeight: 'bold'
                              }}
                            >
                              {bet.side}
                            </span>
                          </div>
                          <div style={{color: '#6c757d', fontSize: '11px'}}>
                            <span style={{fontWeight: 'bold'}}>Bet Id: {bet.id}</span> | {bet.time}
                          </div>
                          <div style={{color: '#6c757d', fontSize: '11px'}}>{bet.phone}</div>
                          <span 
                            className="rounded-circle d-inline-flex align-items-center justify-content-center" 
                            style={{
                              backgroundColor: '#6c757d', 
                              color: 'white', 
                              width: '16px', 
                              height: '16px', 
                              fontSize: '10px',
                              fontWeight: 'bold',
                              marginTop: '4px'
                            }}
                          >
                            i
                          </span>
                        </div>
                      </td>
                      <td className="py-2 px-3">
                        <div className="d-flex flex-column">
                          {bet.status && (
                            <span 
                              className="badge mb-2 text-white"
                              style={{
                                backgroundColor: '#28a745',
                                fontSize: '10px',
                                fontWeight: 'bold',
                                width: 'fit-content'
                              }}
                            >
                              {bet.status}
                            </span>
                          )}
                          <div style={{fontWeight: 'bold', fontSize: '11px', marginBottom: '4px'}}>
                            {bet.type}
                          </div>
                          <div style={{color: '#6c757d', fontSize: '11px'}}>
                            {bet.runnerName}
                          </div>
                        </div>
                      </td>
                      <td className="text-start py-2 px-3">
                        <div style={{fontWeight: 'bold', fontSize: '13px'}}>
                          {bet.betprice}
                        </div>
                        <div style={{color: '#6c757d', fontSize: '11px'}}>
                          {bet.betprice}
                        </div>
                      </td>
                      <td className="text-start py-2 px-3" style={{fontWeight: 'bold', fontSize: '13px'}}>
                        {bet.betAmount}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center py-4" style={{color: '#6c757d'}}>
                      No deleted bets found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Pagination Section */}
        {filteredHistory.length > rowsPerPage && (
          <div className="container-fluid p-3">
            <div className="d-flex justify-content-between align-items-center">
              <div style={{ fontSize: '14px', color: '#6c757d' }}>
                Showing {startIndex + 1} to {Math.min(endIndex, filteredHistory.length)} of {filteredHistory.length} entries
              </div>
              <nav>
                <ul className="pagination pagination-sm mb-0">
                  <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      Previous
                    </button>
                  </li>
                  
                  {/* Page numbers */}
                  {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                    let pageNum;
                    if (totalPages <= 5) {
                      pageNum = i + 1;
                    } else if (currentPage <= 3) {
                      pageNum = i + 1;
                    } else if (currentPage >= totalPages - 2) {
                      pageNum = totalPages - 4 + i;
                    } else {
                      pageNum = currentPage - 2 + i;
                    }
                    
                    return (
                      <li key={pageNum} className={`page-item ${currentPage === pageNum ? 'active' : ''}`}>
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(pageNum)}
                        >
                          {pageNum}
                        </button>
                      </li>
                    );
                  })}
                  
                  <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      Next
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DeletedBets;